import { render, staticRenderFns } from "./CommunityHubSection.vue?vue&type=template&id=15b9c348&"
import script from "./CommunityHubSection.vue?vue&type=script&lang=ts&"
export * from "./CommunityHubSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports